const SummaryTableSchema = [
    {
        objectName: 'calculatorSummary',
        isLoading: 'loadingCalculatorSummary',
        label: 'Results',
        children: [
            {
                label: 'Restocking Fee',
                fieldNames: [
                    'RestockingFeeDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Tax',
                fieldNames: [
                    'RestockingTaxDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Total Restocking Charge',
                fieldNames: [
                    'TotalRestockingChargeDisplay'
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            }
        ]
    },
];

export default SummaryTableSchema;
